import { render, staticRenderFns } from "./ProductTour.vue?vue&type=template&id=5b926195&scoped=true&"
import script from "./ProductTour.js?vue&type=script&lang=js&"
export * from "./ProductTour.js?vue&type=script&lang=js&"
import style0 from "./ProductTour.scss?vue&type=style&index=0&id=5b926195&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b926195",
  null
  
)

export default component.exports